import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Provider from '@react/react-spectrum/Provider';
import DropdownSelector from './src/components/DropdownSelector';

// setting this to False to avoid 'Uncaught Error: only one instance of babel-polyfill is allowed' error
global._babelPolyfill = false;

let app = (
  <Provider theme="lightest">
    <DropdownSelector />
  </Provider>
);

ReactDOM.render(app, document.querySelector('#dropdown'));
